import { Close } from '@mui/icons-material';
import { Alert as A, Box, IconButton, Snackbar, Typography } from '@mui/material';
import { useEffect } from 'react';
import { alertBoxStyle, alertContainerStyle, messageTypographyStyle } from '../styles/AlertStyle';

export interface AlertProps {
  variant: 'success' | 'error';
  message: string;
  open: boolean;
  onClose: () => void;
}

export function Alert(props: AlertProps) {
  const { variant, message, open, onClose } = props;

  useEffect(() => {
    return () => {
      if (open) onClose();
    };
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={(_, reason) => {
        if (reason !== 'clickaway') onClose();
      }}
      sx={{ position: 'static', transform: 'none' }}
    >
      <Box style={alertContainerStyle}>
        <A
          severity={variant}
          variant="filled"
          sx={alertBoxStyle}
          action={
            <IconButton size="small" sx={{ color: 'inherit' }} onClick={onClose}>
              <Close fontSize="small" />
            </IconButton>
          }
        >
          <Typography sx={messageTypographyStyle}>{message}</Typography>
        </A>
      </Box>
    </Snackbar>
  );
}
